import { render } from "./AddDairy.vue?vue&type=template&id=08441d79&scoped=true"
import script from "./AddDairy.vue?vue&type=script&lang=js"
export * from "./AddDairy.vue?vue&type=script&lang=js"

import "./AddDairy.vue?vue&type=style&index=0&id=08441d79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08441d79"]])

export default __exports__